import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SignupComponent } from './Signup/signup.component';
import { FailedComponent } from './Failed/failed.component';
import { SuccessComponent } from './Success/success.component';
/**
 * Contains routes for the top level routes
 * 
 * @export AppRoutingModule
 * @class AppRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forRoot([
            { path: '', component: SignupComponent },
            { path: 'failed/:contractNumber/:creditCheckReference', component: FailedComponent },
            { path: 'failed', component: FailedComponent },
            { path: 'signup', component: SignupComponent },
            { path: 'success/:contractNumber/:documentID/:creditCheckReference', component: SuccessComponent },
            { path: 'success', component: SuccessComponent },
            {path: '**', component: SignupComponent}
            
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.routing.ts
 **/